import admin from './admin';
import dispatcher from './dispatcher';

const routes = [...admin, ...dispatcher];
export default routes;
